import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SongsService, PlaylistService, AlbumsService, HelperService, MessagesServices } from '../../api/';
import { PlayerService } from '../../player/services/player.service';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import * as _ from 'lodash';
import { ArtistService, ScrollService, ScrollParams } from '../../api/';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {AuthService} from '../../api/';
import {Helper} from '../../helper';
declare var $: any;

@Component({
  selector: 'add-to-favorites',
  templateUrl: './add-to-favorites.component.html',
  styleUrls: ['./add-to-favorites.component.css']
})
export class AddToFavoritesComponent implements OnInit {
  @Input() item: any;
  @Input() type: any="AF";
  @Input() aboveTooltip: string = 'below';
  @Input() isFromPlayer: boolean = false; // for the case when user likes a song from inside player
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter();
  private songs: any = new Array<any>();
  artist: any;
  private isAlreadyInPlaylist = false;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';
  msg4: any = '';
  title4: any = '';
  msg5: any = '';
  title5: any = '';
  msg6: any = '';
  title6: any = '';
  private helper = new Helper();
  lyricSlice = 400;
  private scrollParams = new ScrollParams();
  @BlockUI() blockUI: NgBlockUI;
  public onlineOffline1: boolean = navigator.onLine;

  constructor(public authService: AuthService, private router: Router,private scrollService: ScrollService, private sm: MessagesServices, private artistService: ArtistService, private songsService: SongsService, private toastyService: ToastyService, private playlistService: PlaylistService,
    private albumService: AlbumsService, private activatedRoute: Router, private helperService: HelperService, private playerService: PlayerService, ) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
    this.artist = this.item;
    this.getTracks();
    if (screen.width <= 668) {
      this.lyricSlice = 400;
    } else if (screen.width <= 1400) {
      this.lyricSlice = 450;
    } else if (screen.width <= 3070) {
      this.lyricSlice = 550;
    } else {
      this.lyricSlice = 700;
    }
  }

  getTracks() {
    if (this.artist._type == "artist") {
      this.scrollService.toggleProgressBar(true);
      if(this.onlineOffline1) {
        this.artistService.getArtistTracks(this.scrollParams.page, this.artist.id).subscribe((artistSongs) => {
          if(artistSongs)
            artistSongs.forEach((song) => {
              song.playedFrom = 'artist';
              this.songs.push(song);
            });
          this.songs = _.uniqBy(this.songs, 'id');
          this.scrollParams.page++;
          this.scrollService.toggleProgressBar(false);
        });
      }
    }
  }

 //getting system messages
  setMessages() {
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_ADDED_TO_MY-MUSIC-COLLECTION') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_CANNOT_ADD_TO_MY-MUSIC-COLLECTION') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REMOVED_FROM_MY-MUSIC-COLLECTION') {
          this.title3 = this.messages[i].title;
          this.msg3 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_CANNOT_REMOVE_FROM_MY-MUSIC-COLLECTION') {
          this.title4 = this.messages[i].title;
          this.msg4 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ADDED_TO_RADIO') {
          this.title5 = this.messages[i].title;
          this.msg5 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REMOVED_FROM_MY_RADIO') {
          this.title6 = this.messages[i].title;
          this.msg6 = this.messages[i].message;
        }
      }
    }
  }

  toggleToFavorites(event) {
    if(!this.authService.isUserLoggedIn()){
      return  this.router.navigate(['/login']);
    }
    event.stopPropagation();
    event.preventDefault();
    this.blockUI.start('Loading, please wait...');
    if(this.onlineOffline1) {
      let domainInfo = this.helperService.getDomainFromRoute(this.activatedRoute.url);
      if (this.item._type === 'playlist') {
        if (domainInfo.domain !== 'U') {
          domainInfo.object = this.item.id;
        }
        this.playlistService.togglePlaylistToFavorites(this.item.id, this.item.type, domainInfo)
          .subscribe((res) => this.handleSuccess(res),
          (err) => this.handleError(err));
      } else if (this.item._type === 'artist') {
        if (this.songs) {
          for (let i = 0; i < this.songs.length; i++) {
            this.songsService.toggleSongToFavorites(this.songs[i].id, domainInfo)
              .subscribe((res) => this.handleSuccess(res),
              (err) => this.handleError(err));
          }
        }
      } else if(this.item._type === 'song') {
        // case when user likes a song from a radio .. we have to explicitly pass domain R because route can be anything at that time
        if (this.isFromPlayer) {
          domainInfo.domain = 'R';
          domainInfo.object = this.playerService.currentTrackData().id;
        }
        domainInfo.object = (!domainInfo.object) ? this.item.id : domainInfo.object;
        if (this.item.logData) {
          let logData = this.item.logData;
          if (logData.playedFrom) {
            switch (logData.playedFrom) {
              case 'artist':
                domainInfo.domain = 'A-D';
                domainInfo.object = (!logData.parentSlug) ? this.item.id : logData.parentSlug;
                break;
              case 'playlist':
                domainInfo.domain = 'P-D';
                domainInfo.object = (!logData.parentSlug) ? this.item.id : logData.parentSlug;
                break;
              case 'album':
                domainInfo.domain = 'C-D';
                domainInfo.object = (!logData.parentSlug) ? this.item.id : logData.parentSlug;
                break;
            }
          }
        }
        this.songsService.toggleSongToFavorites(this.item.id, domainInfo)
          .subscribe((res) => {
            this.handleSuccess(res);
          },
          (err) => this.handleError(err));
      } else if (this.item._type === 'album') {
        domainInfo.object = this.item.id;
        this.albumService.toggleAlbumToFavorites(this.item.id, domainInfo)
          .subscribe((res) => this.handleSuccess(res),
          (err) => this.handleError(err));
      }
    } else {
      this.blockUI.stop();
    }
  }

  private handleSuccess(res) {
    this.blockUI.stop();
    let total = parseInt(res.successes);
    let title = "";
    let msg = "";
    if (res.successes == 1) {
      title = (total == 1 && res.is_liked === 1) ? this.title1 : this.title3;
      msg = (total == 1 && res.is_liked === 1) ? this.msg1 : this.msg3;
    } else {
      title = (total == 1 || res.is_liked === 1) ? this.title1 : this.title3;
      msg = (total == 1 || res.is_liked === 1) ? this.msg1 : this.msg3;
    }
    if (res.successes && res.domain === 'r') {
      if (res.is_liked === 1) {
        title = this.title5;
        msg = this.msg5;
      } else {
        title = this.title6;
        msg = this.msg6;
      }
    }
    let toastOptions: ToastOptions = {
      title: title,
      msg: msg,
      showClose: true,
      timeout: 2000,
      theme: 'default'
    };
    this.toastyService.success(toastOptions);
    if (res.successes && res.successes.domain === 'r') {
      this.item.favoritedByMe = (res.successes.is_liked === 1) ? true : false;
    } else {
      this.item.favoritedByMe = (res.is_liked === 1) ? true : false;
    }
    this.item.favoritesCount = (res.is_liked === 1) ? parseInt(this.item.favoritesCount) + 1 : parseInt(this.item.favoritesCount) - 1;
    if (res.is_liked === 0) {
      let type = "libraries";
      this.playlistService.myMusicCollectionID.next(this.item.id);
    }
  }

  private handleError(err) {
    let title = (this.item.favoritedByMe) ? this.title2 : this.title4;
    let msg = (this.item.favoritedByMe) ? this.msg2 : this.msg4;
    let toastOptions: ToastOptions = {
      title: title,
      msg: msg,
      showClose: true,
      timeout: 2000,
      theme: 'default'
    };
    this.toastyService.success(toastOptions);
  }

  getMusicLibrary() {
    let type = "libraries";
    let libraries = new Array<any>();
    let librariesForCollectionView = new Array<any>();
    this.songsService.loadUserMusicCollection(this.scrollParams, '', null, 10).subscribe((res) => {
      if (res.length > 0) {
        res.forEach((arrayItem) => {
          if (arrayItem.domain) {
            arrayItem.likedObject = arrayItem.object;
            arrayItem.item.date = arrayItem.created_at;
            arrayItem._type = arrayItem.item._type;
            arrayItem.item.isSongDownloaded = ((!arrayItem.item.isSongDownloaded) ? 'Streaming' : 'Owned');
            let genres = '';
            if (arrayItem.item.genres) {
              arrayItem.item.genres.forEach((genre, index) => {
                if (genres.length < 50) {
                  genres += genre.name + ((index === arrayItem.item.genres.length - 1) ? '' : ',');
                }
              });
            }
            arrayItem.item.genres = genres;
            if (arrayItem.item.type != "P") {
              if (arrayItem.item.lyrics != null) {
                arrayItem.item.songLyrics = arrayItem.item.lyrics;
                arrayItem.item.songLyrics2 = arrayItem.item.songLyrics.slice(0, this.lyricSlice);
              }
            }
            librariesForCollectionView.push(arrayItem.item);
            libraries.push(arrayItem);
          }
        });
      }
      this.scrollParams.page++;
      libraries = _.uniqBy(libraries, 'id');
      librariesForCollectionView = _.uniqBy(librariesForCollectionView, 'id');
      this.helper.setLocalStore(type, libraries);
      this.helper.setLocalStore("librariesForCollectionView", librariesForCollectionView);
      this.blockUI.stop();
    });
  }

}






// WEBPACK FOOTER //
// ./src/app/shared/add-to-favorites/add-to-favorites.component.ts